// src/store/slices/ordersSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../constants/apiUrl";

export const fetchOrders = createAsyncThunk(
  "orders/fetchOrders",
  async (filters, thunkAPI) => {
    try {
      // const params = new URLSearchParams();
      const state = thunkAPI.getState(); // Access Redux state


      console.log(state.auth.userArray.access_token, "state.auth.userArray.access_token");

      const response = await axios.get(
        `${apiUrl}/admin/orders`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.userArray.access_token}`,
          },
        }
      );

      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.errors
          ? Object.values(error.response.data.errors)[0][0]
          : "حدث خطأ أثناء جلب العقارات"
      );
    }
  }
);
export const addOrder = createAsyncThunk(
  "trainers/addOrder",
  async (orderData, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/orders`, orderData, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      console.log(response.data.data);
      
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);
export const updateOrder = createAsyncThunk(
  "orders/updateOrder",
async ({ id, data }, thunkAPI) => {
    try {
      const state = thunkAPI.getState(); // Access Redux state

      const response = await axios.post(`${apiUrl}/admin/orders/${id}`, data, {
        headers: {
          Authorization: `Bearer ${state.auth.userArray.access_token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || "فشل إضافة الصف");
    }
  }
);

const ordersSlice = createSlice({
  name: "orders",
  initialState: {
    list: [],
status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(addOrder.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(addOrder.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(addOrder.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      }).addCase(updateOrder.pending, (state) => {
       state.status = "loading";
        state.error = null;
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
      state.status = "succeeded";
        state.list.push(action.payload);
      })
      .addCase(updateOrder.rejected, (state, action) => {
       state.status = "failed";
        state.error = action.payload;
      })

  },
});

export default ordersSlice.reducer;
